module.exports = __webpack_public_path__ + "static/media/20.1e47969b.jpg";